var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Delete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_delete2",
    transform: "translate(2.7, 1.8)",
    fill: "#b8b8ce",
    fillRule: "nonzero",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8999997,2.02500012 C12.0856513,2.02500012 12.2636995,2.09611605 12.394975,2.22270311 C12.5262504,2.34929017 12.5999994,2.52097892 12.5999994,2.70000006 C12.5999994,2.8790212 12.5262504,3.05070995 12.394975,3.17729701 C12.2636995,3.30388407 12.0856513,3.375 11.8999997,3.375 L11.2,3.375 L11.1978996,3.42292513 L10.5447995,12.245851 C10.5196582,12.5864449 10.361608,12.9051988 10.1024808,13.1379123 C9.84335362,13.3706258 9.50240252,13.5 9.14830042,13.5 L3.45099996,13.5 C3.09689786,13.5 2.75594676,13.3706258 2.49681955,13.1379123 C2.23769234,12.9051988 2.07964125,12.5864449 2.0545,12.245851 L1.4013999,3.42360016 C1.40033828,3.40742119 1.39987142,3.39121086 1.4,3.375 L0.700000002,3.375 C0.514348456,3.375 0.336300673,3.30388407 0.205025213,3.17729701 C0.0737497529,3.05070995 -4.4408921e-16,2.8790212 -4.4408921e-16,2.70000006 C-4.4408921e-16,2.52097892 0.0737497529,2.34929017 0.205025213,2.22270311 C0.336300673,2.09611605 0.514348456,2.02500012 0.700000002,2.02500012 L11.8999997,2.02500012 Z M9.79789957,3.375 L2.80209985,3.375 L3.45170021,12.1500007 L9.14830042,12.1500007 L9.79789957,3.375 Z M7.70000032,-1.11022302e-15 C7.88565186,-1.11022302e-15 8.06369891,0.0711158429 8.19497437,0.197702902 C8.32624983,0.32428996 8.40000002,0.495978876 8.40000002,0.675000015 C8.40000002,0.854021154 8.32624983,1.02571005 8.19497437,1.15229711 C8.06369891,1.27888417 7.88565186,1.35000003 7.70000032,1.35000003 L4.90000001,1.35000003 C4.71434847,1.35000003 4.53630081,1.27888417 4.40502535,1.15229711 C4.27374989,1.02571005 4.20000001,0.854021154 4.20000001,0.675000015 C4.20000001,0.495978876 4.27374989,0.32428996 4.40502535,0.197702902 C4.53630081,0.0711158429 4.71434847,-1.11022302e-15 4.90000001,-1.11022302e-15 L7.70000032,-1.11022302e-15 Z",
    id: "Vector"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Delete-White.06a6be726ca20a2f033e2c8cf8f473cc.svg";